import './bootstrap'
import cleave from 'cleave.js'
import slideout from 'slideout'
import { tns } from 'tiny-slider/src/tiny-slider'

/**
 * Slideshow.
 * 
 * @see https://github.com/ganlanyuan/tiny-slider
 */
if (document.querySelector('.slideshow:not(.banner.banner--solution) .slides')) {
  const slider = tns({
    container: '.slideshow .slides',
    items: 1,
    mode: 'gallery',
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    nav: false,
    lazyload: true,
  })
}

/**
 * Disable form submit buttons on submission.
 */
document.querySelectorAll('form:not(.do-not-disable)').forEach(form => {
  form.addEventListener('submit', () => {
    form.querySelector('button[type="submit"]').disabled = true
  }, false)
})

/**
 * Header Drop Shadow.
 */
window.addEventListener('scroll', () => {
  const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  const appHeader = document.querySelector('.app-header')
  const appHeaderHeight = appHeader.clientHeight
  
  if (scrollTop >= appHeaderHeight) {
    appHeader.classList.add('scrolled')
  } else {
    appHeader.classList.remove('scrolled')
  }
})

/**
 * Scroll to element.
 */
const scrollToElements = document.querySelectorAll('[data-scroll-to]')
for (const scrollToElement of scrollToElements) {
  scrollToElement.addEventListener('click', e => {
    e.preventDefault()

    const selector = scrollToElement.dataset.scrollTo
    const offsetTop = document.querySelector(selector).offsetTop
    const headerHeight = document.querySelector('.app-header').offsetHeight
   
    scroll({
      top: offsetTop - headerHeight,
      behavior: "smooth"
    })
  })
}

/**
 * Slideout Nav
 * https://github.com/mango/slideout
 */
const slideoutNav = new slideout({
  panel: document.getElementById('app-panel'),
  menu: document.getElementById('app-nav-mobile'),
  padding: 320,
  tolerance: 70,
  side: 'right',
  touch: false,
})

document.querySelector('.nav-icon').addEventListener('click', () => {
  slideoutNav.toggle()
})

document.querySelector('#app-nav-mobile .close-icon').addEventListener('click', () => {
  slideoutNav.close()
})

/**
 * Mask phone inputs.
 */
Array.from(document.querySelectorAll('input[type="tel"]')).forEach(el => {
  new cleave(el, {
    numericOnly: true,
    blocks: [0, 3, 0, 3, 4],
    delimiters: ["(", ")", " ", "-"],
  })
})

/**
 * Mask numeric inputs.
 */
Array.from(document.querySelectorAll('input.numeric, input.currency, input.percentage')).forEach(el => {
  new cleave(el, {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    numeralDecimalScale: 2,
  })
})

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
const modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {
    const backdrop = document.createElement('div')
    backdrop.classList.add('modal-backdrop', 'fade', 'show')
    document.querySelector('#app-panel').appendChild(backdrop)
  })

  modal.addEventListener('hidden.bs.modal', e => {
    const backdrop = document.querySelector('.modal-backdrop')
    backdrop.parentNode.removeChild(backdrop)
  })
})
